const SCRIPT_TAG_ID = 'tag-commander';

export const addScriptToDocument = async (uri: string): Promise<HTMLScriptElement> => {
  return new Promise((resolve, reject) => {
    const added = ensureIfCorrectScriptExists(uri);
    if (added) {
      return;
    }
    const script = document.createElement('script');
    script.id = SCRIPT_TAG_ID;
    script.src = uri;
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      resolve(script);
    };
    script.onerror = (err: any) => {
      reject(err);
    };
    return script;
  });
};

const ensureIfCorrectScriptExists = (uri: string) => {
  const elem = document.getElementById(SCRIPT_TAG_ID);
  if (!elem) {
    return false;
  }
  const src = elem.attributes.getNamedItem('src');
  if (uri === src.value) {
    return true;
  }
  document.body.removeChild(elem);
  return false;
};
